export { default } from './P5TextAudio';
